import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const specialtiesReducerSelector = (state: RootState) =>
  state.amwell.activeConsumer.specialties;

export const specialtySelector = createSelector(specialtiesReducerSelector, s => s.details);

export const hasFirstAvailableSelector = createSelector(
  specialtiesReducerSelector,
  s => s.hasFirstAvailable
);

export const specialtyDataSelector = createSelector(specialtySelector, s => s.data);
export const specialtyErrorSelector = createSelector(specialtySelector, s => s.error);
export const specialtyLoadingSelector = createSelector(specialtySelector, s => s.loading);
